var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const map = {
    json: "application/json;charset=UTF-8",
    form: "application/x-www-form-urlencoded;charset=UTF-8",
};
export default function (ctx, next) {
    return __awaiter(this, void 0, void 0, function* () {
        const { config, url } = ctx;
        const headers = url.headers || {};
        const requestType = config && config.requestType;
        if (!headers["Content-Type"] || requestType) {
            if (map[requestType || "json"]) {
                headers["Content-Type"] = map[requestType || "json"];
            }
            else {
                console.error("requestType error:" + requestType);
            }
        }
        url.headers = headers;
        return yield next();
    });
}
